var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrap"},[_c('mq-layout',{attrs:{"mq":"mobile"}},[_c('MobileFrame')],1),_vm._v(" "),_c('mq-layout',{attrs:{"mq":"laptop+"}},[_c('LaptopFrame')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36fba5f9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/educator/Educator.vue
// module id = null
// module chunks = 